import { Popover } from '@material-ui/core';
import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import reactCSS from 'reactcss';

const CustomColorPicker = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { onChange, color, height, width, disabled } = props;

    const handleClick = (event) => {
        if (!disabled) {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const styles = reactCSS({
        default: {
            color: {
                width: width || '100%',
                height: height || '30px',
                borderRadius: '3px',
                background: color || '#ffffff',
                opacity: disabled ? 0.5 : 1,
            },
            swatch: {
                width: width || '100%',
                padding: '6px',
                background: '#ffffff',
                borderRadius: '2px',
                cursor: disabled ? 'not-allowed' : 'pointer',
                display: 'inline-block',
                boxShadow: '0 0 0 1px rgba(0,0,0,.2)',
                opacity: disabled ? 0.7 : 1,
            }
        }
    });

    return (
        <div>
            <div style={styles.swatch} onClick={handleClick}>
                <div style={styles.color} />
            </div>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                <SketchPicker 
                    color={color || '#000000'} 
                    onChange={onChange}
                    styles={{
                        default: {
                            picker: {
                                boxShadow: 'none',
                                padding: '10px',
                                background: 'transparent'
                            }
                        }
                    }}
                    disabled={disabled}
                />
            </Popover>
        </div>
    );
};

export default CustomColorPicker;